
<template>
  <div class="rule" v-if="isShowRuleDetail">
    <div class="rule-title" @click="openRulePopup">
      <span>{{getTitle}}</span>
      <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="vertical-align:middle" ><path fill="#fff" fill-rule="nonzero" d="M16.061 4.94l16.12 15.878a4.5 4.5 0 0 1 0 6.364l-16.12 15.879a1.5 1.5 0 0 1-2.122-2.122L30.06 25.061a1.5 1.5 0 0 0 0-2.122L13.94 7.061a1.5 1.5 0 1 1 2.121-2.122z"/></svg>
    </div>
     <Popup :isShow="isShowRule" :title="ruleName" @clickMask="isShowRule = false">
      <div class="popup-wrapper" slot="content">
        <div class="rules-wrapper">
            <div v-for="(item, index) in ruleAllText" :key="index" class="rule-list">{{item.text}}</div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { getRuleDescription } from '@/api/oldCustomer/index.js'

import {homepageTaskCenterRuleCk} from '../trackEvent'
import Popup from '@/components/popup'
export default {
  name: 'oldCusterRule',
  computed: {
    getTitle () {
      return this.$t('FoodC_C_Detailed_rules_WfnL')
    },
    isShowRuleDetail () {
      return this.ruleName && this.ruleAllText && this.ruleAllText.length
    }
  },
  components: {
    Popup
  },
  data () {
    return {
      isShowRule: false,
      ruleName: '',
      ruleAllText: []
    }
  },
  mounted () {
    this._initData()
  },
  methods: {
    async _initData () {
      const res = await getRuleDescription()
      if (!res.errno) {
        const data = res.data || {}
        this.ruleName = data.ruleName || ''
        this.ruleAllText = data.ruleAllText || []
      }
    },
    openRulePopup () {
      homepageTaskCenterRuleCk({
        activity_type: 1 // 1 订单任务2 消费任务
      })
      this.isShowRule = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.rule
  .rule-title
    display flex
    align-items center
    height 32px
    font-family 'Aspira Light'
    font-size 32px
    color #FFFFFF
    font-weight 200
    .arrow-right
      width 32px
      height 32px
      margin-left 4px
    svg
      width 28px
      height 28px

.popup-wrapper
  margin-top 43px
  height 100%
  overflow-y auto
.rules-wrapper
  overflow hidden
.rule-list
  margin-bottom 34px
  font-family 'PingFangSC Thin'
  font-size 28px
  color #000000
  line-height 34px
  font-weight 200
.rule-list:last-child 
  margin-bottom 0
</style>